import { useRef } from 'react';
import isEqual from 'lodash/isEqual';

import type { ContentHeaderUnifiedQuery$data as ContentHeaderUnifiedQueryType } from '../__generated__/ContentHeaderUnifiedQuery.graphql.ts';

import type { QueryType } from './byLineTypes.ts';

export const useMemoizedObj = (obj: any): any => {
	const ref = useRef(obj);
	if (!isEqual(ref.current, obj)) {
		ref.current = obj;
	}
	return ref.current;
};

export const isFabricEditor = (data?: QueryType): boolean => {
	if (!data) {
		return false;
	}

	if ('singleContent' in data) {
		return false;
	}

	if ('content' in data) {
		const properties =
			(data as ContentHeaderUnifiedQueryType)?.content?.nodes?.[0]?.properties?.nodes || [];
		const editorVersion = properties.find((p) => p?.key === 'editor');
		return editorVersion?.value?.includes('v2') || false;
	}

	return false;
};

export const toUserProps = (
	graphqlUser: any,
): {
	isAnonymous: boolean;
	userId: any;
	fullName: any;
	avatarUrl: any;
} => ({
	isAnonymous: !graphqlUser?.accountId,
	userId: graphqlUser?.accountId ?? undefined,
	fullName: graphqlUser?.displayName,
	avatarUrl: graphqlUser?.profilePicture?.path,
});
